import { type ReactNode } from "react";
import { Slider } from "~/common/mui/Slider/Slider";
import CustomNumberFormat from "~/common/components/CustomNumberFormat";

import classes from "~/features/selectionAssistant/gearbox/components/DimensionsFilter/components/SingleDimensionFilter.module.less";

import { useDelayedUpdateInput } from "~/common/hooks/useDebouncedValue";

type Value = [number | undefined | null, number | undefined | null];
interface Props {
  min: number;
  max: number;
  value: Value;
  onChange: (values: Value) => void;
  label: ReactNode;
}

/**
 * Component representing a single dimension/tech value filter. <br/>
 * It has an inbuilt debouncing mechanism to prevent too many onChange calls - it will only call onChange after 500ms of inactivity.
 */
export const SingleDimensionFilter = ({ min, max, value: valueExt, onChange: onChangeExt, label }: Props) => {
  const { value, onChange } = useDelayedUpdateInput({ value: valueExt, onChange: onChangeExt });
  return (
    <div className={classes.root}>
      <div>{label}</div>
      <Slider
        min={min}
        max={max}
        value={[value[0] ?? min, value[1] ?? max]}
        onChange={(e, value) => {
          onChange(value as [number, number]);
        }}
      />
      <div className={classes.inputContainer}>
        <CustomNumberFormat value={value[0]} label={"Min"} handleState={(e) => onChange([e.floatValue, value[1]])} />
        <CustomNumberFormat value={value[1]} label={"Max"} handleState={(e) => onChange([value[0], e.floatValue])} />
      </div>
    </div>
  );
};
